import { render, staticRenderFns } from "./dailyStatistics.vue?vue&type=template&id=3688b25a&scoped=true"
import script from "./dailyStatistics.vue?vue&type=script&lang=js"
export * from "./dailyStatistics.vue?vue&type=script&lang=js"
import style0 from "./dailyStatistics.vue?vue&type=style&index=0&id=3688b25a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3688b25a",
  null
  
)

export default component.exports